import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const getId = (store, key) => {
  let id = store.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    store.setItem(key, id);
  }
  return id;
};

export default function TrackPageViews() {
  const { pathname } = useLocation();

  useEffect(() => {
    axios.post(`${API}/api/track`, {
      visitor_id: getId(localStorage, "wcifmd_visitor"),
      session_id: getId(sessionStorage, "wcifmd_session"),
      path: pathname,
      referrer: document.referrer || "",
    }).catch(() => {});
  }, [pathname]);

  return null;
}
